import React, { useEffect, useState, useCallback } from "react";
import { Card, Modal, ModalHeader, ModalBody, Spinner, Container, Row, Col, CardBody, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, FormFeedback, Label, Input } from "reactstrap";
import SimpleBar from "simplebar-react";
import SimpleDonutCharts from "./FileManagerCharts";
import DeleteModal from "../../Components/Common/DeleteModal";
import moment from "moment";
import Select from "react-select";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { isEmpty, clone, merge } from "lodash";
import Dropzone from "react-dropzone";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../store/app/action";
import { addNewStorageFolder, updateStorageFolder, deleteStorageFolder, getStorageFolder, resetStorageFolderState, getStorageFolderLoading } from "../../store/storageFolder/action";
import { addNewStorageFile, updateStorageFile, deleteStorageFile, getStorageFile, resetStorageFileState, getStorageFileLoading } from "../../store/storageFiles/action";
import { api } from "../../config";
import { resetDepartmentState, getDepartment } from "../../store/department/action";
import ModalImage from "react-modal-image";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link } from "react-router-dom";

const FileManager = () => {
  const dispatch = useDispatch();
  const [storageFolderList, setStorageFolderList] = useState([]);
  const [storageFileList, setStorageFileList] = useState([]);
  const [folderClicked, setFolderClicked] = useState(false);
  const [folder, setFolder] = useState(null);
  const [file, setFile] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
  const [modalFolder, setModalFolder] = useState(false);
  const [modalMoveFolderOrFile, setModalMoveFolderOrFile] = useState(false);
  const [moveType, setMoveType] = useState(null);
  const [modalFile, setModalFile] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [folderList, setFolderList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [folderActiveId, setFolderActiveId] = useState(0);
  const [fileActiveId, setFileActiveId] = useState(0);
  const [isMove, setIsMove] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);

  const [sidebarData, setSidebarData] = useState(false);
  const [positionIdSelected, setPositionIdSelected] = useState(null);
  const [departementIdSelected, setDepartementIdSelected] = useState(null);
  const [activeFolder, setActiveFolder] = useState("all");

  const [departmentOptList, setDepartmentOptList] = useState([]);

  const [dataFolderAndFile, setDataFolderAndFile] = useState({
    folders: [],
    file: null,
  });

  const [selectedMoveFolder, setSelectedMoveFolder] = useState({
    data: null,
    type: null,
  });

  const [searchTerm, setSearchTerm] = useState("");

  document.title = "File Manager | Enterprise Resources Planning";
  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, storageFolders, storageFolder, isStorageFolderCreated, isStorageFolderSuccess, loadingFolder, errorFile, storageFiles, clients, companies, departments, departmentLoading, companiesLoading, loadingFile, isStorageMoveCreated, isStorageRenameCreated, positions, positionLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    storageFolders: state.StorageFolder.storageFolders,
    storageFolder: state.StorageFolder.storageFolder,
    isStorageFolderCreated: state.StorageFolder.isStorageFolderCreated,
    isStorageFolderSuccess: state.StorageFolder.isStorageFolderSuccess,
    loadingFolder: state.StorageFolder.loading,
    errorFile: state.StorageFolder.error,
    storageFiles: state.StorageFile.storageFiles,
    clients: state.Client.clients,
    companies: state.Company.companies,
    companiesLoading: state.Company.loading,
    loadingFile: state.StorageFile.loading,
    isStorageMoveCreated: state.StorageMove.isStorageMoveCreated,
    isStorageRenameCreated: state.StorageRename.isStorageRenameCreated,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
  }));

  const toggleFolder = (type) => {
    setActiveFolder(type);
    setDataFolderAndFile({
      folders: [],
      file: null,
    });
    let arrFiles = storageFolders;
    if (type !== "all") {
      arrFiles = storageFolders.filter((file) => file.departmentId === type);
    }
    setStorageFolderList(arrFiles.filter((el) => el.parentId === null));
  };

  const onClickDelete = (folder) => {
    setDeleteData(folder);
    setDeleteModal(true);
  };

  const handleDeleteFolder = () => {
    if (deleteData) {
      dispatch(deleteStorageFolder(deleteData));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    if (companySelected && branchSelected) {
      setStorageFolderList([]);
      setStorageFileList([]);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setDepartementIdSelected(obj?.data?.user?.user_department && obj?.data?.user?.user_department?.id);
        setPositionIdSelected(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.id);
        dispatch(resetStorageFolderState());
        dispatch(getStorageFolder({ status: 2, companyId: companySelected.value, branchId: branchSelected.value }));
        dispatch(resetStorageFileState());
        dispatch(getStorageFile({ status: 2, companyId: companySelected.value, branchId: branchSelected.value }));
        dispatch(resetDepartmentState());
        dispatch(getDepartment({ status: 2, companyId: companySelected.value, branchId: branchSelected.value }));
      }
    }
  }, [companySelected, branchSelected]);

  const folderToggle = useCallback(() => {
    if (modalFolder) {
      setModalFolder(false);
      folderValidation.resetForm();
      setFolder(null);
      setFile(null);
    } else {
      const lastItem = dataFolderAndFile.folders.at(-1);
      if (lastItem) {
        folderValidation.setFieldValue("department", lastItem.folder_department === null ? null : { label: lastItem.folder_department.name, value: lastItem.folder_department.id });
      } else {
        if (activeFolder !== "all") {
          const found = departmentOptList[0].options.find((el) => el.value === activeFolder);
          folderValidation.setFieldValue("department", found || null);
        } else {
          const found = departmentOptList[0]?.options?.find((el) => el.value === departementIdSelected);
          folderValidation.setFieldValue("department", found || null);
        }
      }
      setModalFolder(true);
    }
  }, [modalFolder, departementIdSelected, departmentOptList, dataFolderAndFile.folders]);

  const folderOrFileMoveToggle = useCallback((type = null) => {
    if (modalMoveFolderOrFile) {
      setModalMoveFolderOrFile(false);
    } else {
      setMoveType(type);
      setModalMoveFolderOrFile(true);
      setSelectedMoveFolder((prevVal) => {
        return {
          ...prevVal,
          data: folderList[0].options[0],
          type: type,
        };
      });
    }
  }, [modalMoveFolderOrFile, folderList]);

  const fileToggle = useCallback(() => {
    if (modalFile) {
      setModalFile(false);
      setFile(null);
    } else {
      setModalFile(true);
    }
  }, [modalFile]);

  const handleFolderRename = useCallback((arg, type) => {
    const folder = arg;
    if (type === "folder") {
      setFolder({
        id: folder.id,
        name: folder.name,
        department: folder.folder_department === null ? null : { label: folder.folder_department.name, value: folder.folder_department.id },
        parentId: folder.parentId ?? null,
      });
    } else {
      const originalname = folder.originalname ?? "";
      const nameOnly = originalname.substring(0, originalname.lastIndexOf("."));
      setFile({
        ...folder,
        name: nameOnly,
      });
    }

    setIsEdit(true);
    if (folder.type === "file") {
      fileToggle();
    } else {
      folderToggle();
    }
  },
    [folderToggle, fileToggle]
  );

  const handleFileClick = useCallback((arg) => {
    const file = arg;
    let company = "Not set";
    if (file?.file_company?.name) {
      company = file?.file_company?.name;
    }
    setFile({
      id: file.id,
      fileId: file.id,
      folder: {
        label: file.file_folder.name + " - " + company,
        value: file.folderId,
      },
    });
    setIsEdit(true);
    fileToggle();
  },
    [fileToggle]
  );

  const folderValidation = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: (folder && folder.name) ?? "",
      department: (folder && folder.department) || null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Folder Name"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const lastItem = dataFolderAndFile.folders.at(-1);
        let updateFolder = {
          id: folder ? folder.id : 0,
          name: values.name,
          clientId: clientSelected?.value ?? null,
          companyId: companySelected?.value ?? null,
          branchId: branchSelected?.value ?? null,
          isPrivate: false,
        };

        if (lastItem) {
          updateFolder = {
            ...updateFolder,
            departmentId: lastItem.departmentId ?? null,
            posisitonId: lastItem.posisitonId ?? null,
            parentId: folder.department?.value !== values.department?.value ? null : lastItem.id ?? null,
          };
        } else {
          updateFolder = {
            ...updateFolder,
            departmentId: departementIdSelected?.value ?? null,
            posisitonId: positionIdSelected?.value ?? null,
            parentId: null,
          };
        }

        if (values.department) {
          updateFolder = {
            ...updateFolder,
            departmentId: values.department?.value ?? null,
          };
        }
        dispatch(updateStorageFolder(updateFolder));
        setIsMove(true);
        folderValidation.resetForm();
      } else {
        const lastItem = dataFolderAndFile.folders.at(-1);
        let newFolder = {
          name: values.name,
          clientId: clientSelected?.value ?? null,
          companyId: companySelected?.value ?? null,
          branchId: branchSelected?.value ?? null,
          isPrivate: false,
        };

        if (lastItem) {
          newFolder = {
            ...newFolder,
            departmentId: lastItem.departmentId ?? null,
            posisitonId: lastItem.posisitonId ?? null,
            parentId: lastItem.id ?? null,
          };
        } else {
          newFolder = {
            ...newFolder,
            departmentId: departementIdSelected?.value ?? null,
            posisitonId: positionIdSelected?.value ?? null,
            parentId: null,
          };
        }

        if (values.department) {
          newFolder = {
            ...newFolder,
            departmentId: values.department?.value ?? null,
          };
        }

        dispatch(addNewStorageFolder(newFolder));
        setIsMove(true);
        folderValidation.resetForm();
      }
      folderToggle();
    },
  });

  const fileValidation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (file && file.name) ?? "",
    },
    validationSchema: Yup.object({
      // fileId: Yup.number().required("Please Enter File Id"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const originalname = file.originalname;
        const ext = originalname.substring(originalname.lastIndexOf(".")); // ".jpg"
        const result = values.name + ext;
        const updateFile = {
          ...file,
          originalname: result,
        };

        dispatch(updateStorageFile(updateFile));
        fileValidation.resetForm();
      } else {
        // const newFile = {
        //   fileId: values.fileId,
        //   folderId: values.folder.value,
        // };
        // //dispatch(addNewStorageMove(newFile));
        // setIsMove(true);
        // fileValidation.resetForm();
      }
      fileToggle();
    },
  });

  const handleUpload = (files) => {
    dispatch(getStorageFileLoading());
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    const lastItem = dataFolderAndFile.folders.at(-1);

    if (lastItem) {
      let dataFile = {
        clientId: clientSelected?.value ?? null,
        companyId: companySelected?.value ?? null,
        branchId: branchSelected?.value ?? null,
        departmentId: lastItem.departmentId ?? null,
        posisitonId: lastItem.posisitonId ?? null,
      };

      formData.append("folderId", lastItem.id ?? null);
      formData.append("clientId", dataFile.clientId);
      formData.append("companyId", dataFile.companyId);
      formData.append("branchId", dataFile.branchId);
      formData.append("departmentId", dataFile.departmentId);
      formData.append("posisitonId", dataFile.posisitonId);
      dispatch(addNewStorageFile(formData));
    } else {
      toast.error("SILAHKAN PILIH FOLDER ATAU BUAT FOLDER BARU UNTUK UPLOAD FILE", { autoClose: 3000 });
    }
  };

  const handleDeleteFile = (id) => {
    dispatch(deleteStorageFile(id));
  };

  const handleSearchFolder = (value) => {
    setSearchTerm(value);
    const filterData = storageFolders.filter((el) => {
      const matchDept = activeFolder === "all" || el.departmentId === activeFolder;
      let matchParent = false;
      if (dataFolderAndFile.folders.length > 0) {
        matchParent = el.parentId !== null;
      } else {
        matchParent = el.parentId === null;
      }

      return matchDept && matchParent;
    });
    const lastItem = dataFolderAndFile.folders.at(-1);
    const arrFileByParentId = storageFiles.filter((el) => el.folderId === lastItem?.id).map((el) => ({ ...el, name: el.originalname, type: "file" }));

    const margeData = [...filterData, ...arrFileByParentId];
    const searchData = margeData.filter((el) => el.name.toLowerCase().includes(value.toLowerCase()));
    setStorageFolderList(searchData);
  };

  const handleSearchFiles = (value) => {
    const filteredBooks = storageFiles.filter(({ originalname }) => originalname.toLowerCase().includes(value.toLowerCase()));
    setStorageFileList(filteredBooks);
  };

  useEffect(() => {
    if (!isEmpty(departments)) {
      setDepartmentList(departments);
    }
  }, [departments]);

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const formatByte2 = (bytes, decimals = 2) => {
    if (bytes === 0) return 0;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  };

  const handleMoveFolderOrFile = () => {
    switch (selectedMoveFolder.type) {
      case "folders": {
        storageFolderList
          .filter((el) => el.isChecked && el?.type === undefined)
          .map((el) => {
            return {
              ...el,
              parentId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            };
          })
          .forEach((folder) => {
            let param = {
              id: folder.id,
              name: folder.name,
              clientId: folder.clientId,
              companyId: folder.companyId,
              branchId: folder.branchId,
              parentId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            }
            dispatch(updateStorageFolder(param));
          });
        break;
      }
      case "folder": {
        const foundFolder = storageFolderList
          .filter((el) => el?.type === undefined)
          .map((el) => {
            return {
              ...el,
              parentId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            };
          })
          .find((folder) => folder.id === folderActiveId);

        if (foundFolder) {
          let param = {
            id: foundFolder.id,
            name: foundFolder.name,
            clientId: foundFolder.clientId,
            companyId: foundFolder.companyId,
            branchId: foundFolder.branchId,
            parentId: selectedMoveFolder.data.value,
            departmentId: selectedMoveFolder.data.departmentId,
          }
          dispatch(updateStorageFolder(param));
        }
        break;
      }
      case "files": {
        storageFolderList
          .filter((el) => el.isChecked && el.type === "file")
          .map((el) => {
            return {
              ...el,
              folderId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            };
          })
          .forEach((file) => {
            let param = {
              id: file.id,
              name: file.name,
              clientId: file.clientId,
              companyId: file.companyId,
              branchId: file.branchId,
              folderId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            }
            dispatch(updateStorageFile(param));
          });
        break;
      }
      case "file": {
        const foundFile = storageFolderList
          .filter((el) => el.type === "file")
          .map((el) => {
            return {
              ...el,
              folderId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            };
          })
          .find((file) => file.id === fileActiveId);

        if (foundFile) {
          let param = {
            id: foundFile.id,
            name: foundFile.name,
            clientId: foundFile.clientId,
            companyId: foundFile.companyId,
            branchId: foundFile.branchId,
            folderId: selectedMoveFolder.data.value,
            departmentId: selectedMoveFolder.data.departmentId,
          }
          dispatch(updateStorageFile(param));
        }
        break;
      }
      default:
        storageFolderList
          .filter((el) => el.isChecked && el?.type === undefined)
          .map((el) => {
            return {
              ...el,
              parentId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            };
          })
          .forEach((folder) => {
            let param = {
              id: folder.id,
              name: folder.name,
              clientId: folder.clientId,
              companyId: folder.companyId,
              branchId: folder.branchId,
              parentId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            }
            dispatch(updateStorageFolder(param));
          });
        storageFolderList
          .filter((el) => el.isChecked && el.type === "file")
          .map((el) => {
            return {
              ...el,
              folderId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            };
          })
          .forEach((file) => {
            let param = {
              id: file.id,
              name: file.name,
              clientId: file.clientId,
              companyId: file.companyId,
              branchId: file.branchId,
              folderId: selectedMoveFolder.data.value,
              departmentId: selectedMoveFolder.data.departmentId,
            }
            dispatch(updateStorageFile(param));
          });

        break;
    }

    folderOrFileMoveToggle();
  };

  const checkedAll = () => {
    setStorageFolderList((prevVal) => {
      const allChecked = prevVal.every((item) => item.isChecked);
      return prevVal.map((item) => ({
        ...item,
        isChecked: !allChecked,
      }));
    });
  };

  const checkedFileAll = () => {
    setStorageFileList((prevVal) => {
      const allChecked = prevVal.every((item) => item.isChecked);
      return prevVal.map((item) => ({
        ...item,
        isChecked: !allChecked,
      }));
    });
  };

  useEffect(() => {
    if (isMove && companySelected && branchSelected) {
      // const lastItem = dataFolderAndFile.folders.at(-1);
      // setStorageFolderList([]);
      // dispatch(resetStorageFolderState());
      dispatch(getStorageFolder({ status: 2, companyId: companySelected.value, branchId: branchSelected.value }));
      // dispatch(resetStorageFileState());
      // if (lastItem?.id) {
      //   dispatch(getStorageFile({ status: 2, companyId: companySelected.value, branchId: branchSelected.value, folderId: lastItem?.id }));
      // } else {
      //   dispatch(getStorageFile({ status: 2, companyId: companySelected.value, branchId: branchSelected.value }));
      // }
      setIsMove(false);
    }
  }, [isMove, dispatch, folderActiveId]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var data = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setDepartmentOptList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(storageFolders)) {
      var data = [];
      var opt = [{ label: "RESET", value: null }];
      storageFolders.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name + " - " + item?.folder_department?.name, value: id, departmentId: item?.folder_department?.id ?? null };
        opt.push(obj);
      });
      var option = {
        options: opt.sort((a, b) =>
          a.label.localeCompare(b.label, undefined, {
            numeric: true,
            sensitivity: "base",
          })
        ),
      };
      data.push(option);
      setFolderList(data);
    }
  }, [storageFolders]);

  const handleFolderClick = (data) => {
    setSearchTerm("");
    setDataFolderAndFile((prevVal) => {
      return {
        ...prevVal,
        folders: [...prevVal.folders, data],
      };
    });
    setFolderActiveId(data.id);

    const arrFolderByParentId = storageFolders.filter((el) => {
      const matchDept = activeFolder === "all" || el.departmentId === activeFolder;
      return el.parentId === data.id && matchDept;
    });


    const arrFileByParentId = storageFiles.filter((el) => el.folderId === data.id).map((el) => ({ ...el, name: el.originalname, type: "file" }));
    const margeData = [...arrFolderByParentId, ...arrFileByParentId];
    setStorageFolderList(margeData);

    // dispatch(getStorageFileLoading());
    // dispatch(getStorageFolderLoading());
    // dispatch(resetStorageFileState());
    // dispatch(resetStorageFolderState());
    // dispatch(getStorageFile({ folderId: data.id }));
    // dispatch(getStorageFolder({ status: 2, companyId: companySelected.value, branchId: branchSelected.value, folderId: data.id }));
  };

  useEffect(() => {
    const lastItem = dataFolderAndFile.folders.at(-1);
    let filterData = storageFolders
      .filter((el) => {
        const matchDept = activeFolder === "all" || el.departmentId === activeFolder;
        let matchParent = false;
        if (lastItem) {
          matchParent = el.parentId === lastItem.id;
        } else {
          matchParent = el.parentId === null;
        }
        return matchDept && matchParent;
      })
      .map((el) => ({ ...el, isChecked: false }));

    const arrFileByParentId = storageFiles.filter((el) => el.folderId === lastItem?.id).map((el) => ({ ...el, name: el.originalname, type: "file" }));
    const margeData = [...filterData, ...arrFileByParentId];
    if (!isEmpty(margeData)) {
      setStorageFolderList(margeData);
    }
    else {
      setStorageFolderList([]);
    }
  }, [storageFolders]);

  useEffect(() => {
    const newStorageFolderList = storageFolderList.filter((item) => item.type !== "file");
    const lastItem = dataFolderAndFile.folders.at(-1);
    const arrFileByParentId = storageFiles.filter((el) => el.folderId === lastItem?.id).map((el) => ({ ...el, name: el.originalname, type: "file" }));

    const margeData = [...newStorageFolderList, ...arrFileByParentId];
    if (!isEmpty(margeData)) {
      setStorageFolderList(margeData);
    }
    else {
      setStorageFolderList([]);
    }
  }, [storageFiles]);

  useEffect(() => {
    // setStorageFileList(storageFiles.map((el) => ({ ...el, isChecked: false })));
    if (fileList.length === 0) setFileList(storageFiles);
  }, [storageFiles]);

  const renderIconImgList = (file) => {
    const ext = file.mimetype.split("/");
    if (ext[1] === "pdf") {
      return (
        <Link to={`${api.MEDIA_URL}/media/${file.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
          <i className="ri-file-pdf-line me-1 align-bottom text-danger display-6"></i>
        </Link>
      );
    } else if (ext[0] === "image") {
      return (
        <div className="profile-user position-relative d-inline-block mx-auto">
          <ModalImage showRotate={true} small={api.MEDIA_URL + "/media/" + file.filename + "-w-50"} large={api.MEDIA_URL + "/media/" + file.filename} alt={file.originalname} className="avatar-sm img-thumbnail user-profile-image" />
          {/* <LazyLoadImage
            src={api.MEDIA_URL + "/media/" + file.filename + "-w-50"}
            alt=""
            className="avatar-sm img-thumbnail user-profile-image"
            effect="blur" /> */}
        </div>
      );
    } else if (ext[0] === "application") {
      return (
        <Link to={`${api.MEDIA_URL}/media/${file.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
          <i className="ri-file-excel-line me-1 align-bottom text-success display-6"></i>
        </Link>
      );
    } else {
      return (
        <Link to={`${api.MEDIA_URL}/media/${file.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
          <i className="ri-file-zip-line me-1 align-bottom text-danger display-6"></i>
        </Link>
      );
    }
  };

  function sidebarOpen(value) {
    const element = document.getElementsByTagName("body")[0];
    element.classList.add(value);
  }

  function sidebarClose(value) {
    const element = document.getElementsByTagName("body")[0];
    element.classList.remove(value);
  }

  useEffect(() => {
    sidebarOpen("file-detail-show");
  }, []);

  const favouriteBtn = (ele) => {
    if (ele.closest("button").classList.contains("active")) {
      ele.closest("button").classList.remove("active");
    } else {
      ele.closest("button").classList.add("active");
    }
  };

  const fileSidebar = () => {
    document.getElementById("folder-overview").style.display = "none";
    document.getElementById("file-overview").style.display = "block";
  };

  const renderNav = () => {
    let parentDept = "SEMUA DEPT";
    if (activeFolder !== "all") {
      parentDept = departmentList.find((el) => el.id === activeFolder)?.name;
    }
    const folderNames = dataFolderAndFile.folders.map((f) => f.name);

    let parent = parentDept;
    if (parentDept === "SEMUA DEPT" && activeFolder === "all") {
      if (dataFolderAndFile.folders.length > 0 && dataFolderAndFile.folders[0].folder_department.name) {
        parent = `${parentDept}/${dataFolderAndFile.folders[0].folder_department.name}`;
      }
    }
    const string = [parent, ...folderNames].join("/");
    return <div>{string}</div>;
  };

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={() => handleDeleteFolder()} onCloseClick={() => setDeleteModal(false)} />
      <div className="page-content">
        <Container fluid>
          <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div className="file-manager-sidebar">
              <div className="p-3 d-flex flex-column h-100">
                <div className="mb-3">
                  <h5 className="mb-0 fw-semibold">
                    File Management
                    {(loadingFolder || loadingFile) && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                      </>
                    )}
                  </h5>
                </div>
                <SimpleBar className="mx-n4 px-4 file-menu-sidebar-scroll">
                  <ul className="list-unstyled file-manager-menu">
                    <li>
                      <a data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="true" aria-controls="collapseExample">
                        <i className="ri-folder-2-line align-bottom me-2 fs-15"></i> <span className="file-list-link fs-15">Departemen</span>
                      </a>
                      <div className="collapse show mt-2" id="collapseExample">
                        <ul className="sub-menu list-unstyled">
                          <li>
                            <a
                              href="#!"
                              onClick={() => {
                                // setFolderClicked(false);
                                toggleFolder("all");
                              }}
                            >
                              SEMUA DEPT {(storageFolders.filter((el) => el.parentId === null) || []).length > 0 && <button className="btn btn-sm mb-1 btn-icon btn-topbar btn-info rounded-circle shadow-none">{(storageFolders.filter((el) => el.parentId === null) || []).length}</button>}
                            </a>
                          </li>
                          {(departmentList || []).map((item, key) => {
                            return (
                              <li key={key}>
                                <a
                                  href="#!"
                                  onClick={() => {
                                    // setFolderClicked(false);
                                    toggleFolder(item.id);
                                  }}
                                >
                                  {item.name} {(storageFolders || []).filter((el) => el.departmentId === item.id && el.parentId === null).length > 0 && <button className="btn btn-sm mb-1 btn-icon btn-topbar btn-info rounded-circle shadow-none">{(storageFolders || []).filter((el) => el.departmentId === item.id && el.parentId === null).length}</button>}{" "}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>
                  </ul>
                </SimpleBar>

                <div className="mt-auto">
                  <h6 className="fs-11 text-muted text-uppercase mb-3">Storage Status</h6>
                  <div className="d-flex align-items-center mb-3">
                    <div className="flex-shrink-0">
                      <i className="ri-database-2-line fs-17"></i>
                    </div>
                    <div className="flex-grow-1 ms-3 overflow-hidden">
                      <div className="progress mb-2 progress-sm">
                        <div className="progress-bar bg-success" role="progressbar" style={{ width: parseFloat((fileList || []).reduce((a, v) => (a = a + parseFloat(v.size)), 0) / 26843570600).toFixed(2) * 100 + "%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <span className="text-muted fs-12 d-block text-truncate">
                        <b>{formatBytes((fileList || []).reduce((a, v) => (a = a + parseFloat(v.size)), 0))}</b> used of <b>25 GB</b>{" "}
                      </span>
                    </div>
                  </div>
                  <div className="mb-3">
                    <Dropzone
                      multiple={true}
                      onDrop={(acceptedFiles) => {
                        handleUpload(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dz-clickable" style={{ cursor: "pointer", height: "140px" }} {...getRootProps({ className: "dropzone" })}>
                          <div className="dz-message needsclick">
                            <div>
                              <i className="display-3 text-muted ri-upload-cloud-2-fill" />
                              <input {...getInputProps()} />
                            </div>
                            <h5>
                              Drop files or <br /> click here to upload.
                            </h5>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  </div>
                </div>
              </div>
            </div>
            <div className="file-manager-content w-100 p-3 py-0">
              <div id="folder-list" className="mb-2">
                <div>
                  <div className="pe-3 ps-3">
                    <div className="pt-3 d-flex gap-2 align-items-center">
                      <div className="search-box me-2 mb-3 d-inline-block flex-grow-1">
                        <input
                          onChange={(e) => {
                            handleSearchFolder(e.target.value);
                          }}
                          value={searchTerm}
                          id="search-bar-0"
                          type="text"
                          className="form-control search"
                          placeholder={`${storageFolderList.length} Search...`}
                        />
                        <i className="bx bx-search-alt search-icon"></i>
                      </div>
                      <div className="hstack gap-2 d-inline-block">
                        {dataFolderAndFile.folders.length > 0 && (
                          <button
                            type="button"
                            className="btn btn-warning text-nowrap create-folder-modal me-2"
                            onClick={() => {
                              setSearchTerm("");
                              const foldersDeleteLast = dataFolderAndFile.folders.slice(0, -1);
                              setDataFolderAndFile((prevVal) => ({ ...prevVal, folders: foldersDeleteLast }));
                              const lastItem = foldersDeleteLast.at(-1);
                              const filterData = storageFolders
                                .filter((el) => {
                                  const matchDept = activeFolder === "all" || el.departmentId === activeFolder;
                                  let matchParent = false;
                                  if (lastItem) {
                                    matchParent = el.parentId === lastItem.id;
                                  } else {
                                    matchParent = el.parentId === null;
                                  }
                                  return matchDept && matchParent;
                                })
                                .map((el) => ({ ...el, isChecked: false }));

                              const arrFileByParentId = storageFiles.filter((el) => el.folderId === lastItem?.id).map((el) => ({ ...el, name: el.originalname, type: "file" }));
                              const margeData = [...filterData, ...arrFileByParentId];
                              setStorageFolderList(margeData);
                            }}
                          >
                            <i className="ri-arrow-go-back-line me-1 align-bottom"></i> Back
                          </button>
                        )}
                        <button
                          className="btn btn-success text-nowrap create-folder-modal"
                          onClick={() => {
                            folderToggle();
                            setIsEdit(false);
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Tambah Folder
                        </button>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="form-check notification-check hstack gap-2 mb-3">
                        <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={storageFolderList.every((item) => item.isChecked)} onChange={checkedAll} />
                        <label className="form-check-label" htmlFor="checkBoxAll">
                          Pilih Semua
                        </label>

                        {storageFolderList.some((item) => item.isChecked) && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-sm btn-info me-2"
                              id="print-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                folderOrFileMoveToggle("all");
                              }}
                            >
                              MOVE TO FOLDER
                            </button>
                          </div>
                        )}
                      </div>
                      {renderNav()}
                    </div>
                  </div>
                  <SimpleBar className="file-manager-content-scroll">
                    <Row id="folderlist-data" className="p-0 m-0">
                      {(storageFolderList || [])
                        .filter((f) => f.type !== "file")
                        .sort((a, b) => {
                          if (a.type === "file" && b.type !== "file") return 1;
                          if (b.type === "file" && a.type !== "file") return -1;
                          if (a.type === "file" && b.type === "file") return 0;
                          return (a.name ?? "").localeCompare(b.name ?? "", undefined, {
                            numeric: true,
                            sensitivity: "base",
                          });
                        })
                        .map((item, key) => {
                          let fileSize = 0;
                          item.folder_file &&
                            item.folder_file.length > 0 &&
                            item.folder_file.forEach((f) => {
                              fileSize += Number(f.size);
                            });

                          return (
                            <Col xxl={3} className="col-6 folder-card" key={key}>
                              <Card className="bg-light shadow-none" id={"folder-" + item.id}>
                                <CardBody>
                                  <input
                                    type="checkbox"
                                    className="dataCheckbox me-2 form-check-input"
                                    checked={item.isChecked}
                                    onChange={() => {
                                      setStorageFolderList((prevVal) => prevVal.map((el) => (el.id === item.id ? { ...el, isChecked: !el.isChecked } : el)));
                                    }}
                                  />
                                  <span className="text-muted fs-11">{item?.folder_department?.name ?? "-"}</span>
                                  <div className="d-flex align-items-center" style={{ cursor: "pointer" }} onClick={() => handleFolderClick(item)}>
                                    <div className="me-2">
                                      <i className="ri-folder-2-fill align-bottom text-warning display-3"></i>
                                    </div>
                                    <h6 className="fs-15 folder-name mb-1 flex-grow-1">{item?.name ?? "-"}</h6>
                                  </div>
                                  <div className="">
                                    <div className="d-flex align-items-center">
                                      <div className="me-auto flex-grow-1">{item.folder_file && item.folder_file.length} Files</div>
                                      <span className="text-muted">{formatBytes(fileSize)}</span>
                                      <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-ghost-primary btn-icon btn-sm dropdown">
                                          <i className="ri-more-2-fill fs-16 align-bottom" />
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                          <DropdownItem className="view-item-btn" onClick={() => handleFolderClick(item)}>
                                            OPEN
                                          </DropdownItem>
                                          <DropdownItem
                                            className="edit-folder-list"
                                            onClick={() => {
                                              handleFolderRename(item, "folder");
                                              setFolderActiveId(item.id);
                                            }}
                                          >
                                            RENAME
                                          </DropdownItem>
                                          <DropdownItem
                                            className="edit-folder-list"
                                            onClick={() => {
                                              //handleFolderMove(item, "folder");
                                              setFolderActiveId(item.id);
                                              folderOrFileMoveToggle("folder");
                                            }}
                                          >
                                            MOVE TO FOLDER
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={() => {
                                              onClickDelete(item);
                                            }}
                                            className={userType !== "admin" ? "d-none" : ""}
                                          >
                                            DELETE
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                    </Row>
                    <Row id="folderlist-data" className="p-0 m-0">
                      {(storageFolderList || [])
                        .filter((f) => f.type === "file")
                        .sort((a, b) => {
                          if (a.type === "file" && b.type !== "file") return 1;
                          if (b.type === "file" && a.type !== "file") return -1;
                          if (a.type === "file" && b.type === "file") return 0;
                          return (a.name ?? "").localeCompare(b.name ?? "", undefined, {
                            numeric: true,
                            sensitivity: "base",
                          });
                        })
                        .map((item, key) => {
                          let fileSize = 0;
                          item.folder_file &&
                            item.folder_file.length > 0 &&
                            item.folder_file.forEach((f) => {
                              fileSize += Number(f.size);
                            });

                          return (
                            <Col xxl={6} className="col-6" key={key}>
                              <div className="mb-3 border">
                                <div className="d-flex p-2 align-items-center">
                                  <div className="flex-grow-1">
                                    <div className="d-flex align-items-center mb-0">
                                      <input
                                        type="checkbox"
                                        className="dataCheckbox me-2 form-check-input"
                                        checked={item.isChecked}
                                        onChange={() => {
                                          setStorageFolderList((prevVal) => prevVal.map((el) => (el.id === item.id ? { ...el, isChecked: !el.isChecked } : el)));
                                        }}
                                      />
                                      <div className="me-2">{renderIconImgList(item)}</div>
                                      <div className="text-wrap d-block overflow-hidden">
                                        <p className="mb-0 fw-semibold">{item.originalname}</p>
                                        <p className="text-muted  mb-0 fs-11">
                                          {formatBytes(item.size)} <em className="ms-1 ">{moment(item.createdat).fromNow()}</em>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-shrink-0">
                                    <UncontrolledDropdown>
                                      <DropdownToggle tag="button" className="btn btn-ghost-primary btn-icon btn-sm dropdown">
                                        <i className="ri-more-2-fill fs-16 align-bottom" />
                                      </DropdownToggle>
                                      <DropdownMenu className="dropdown-menu-end">
                                        {/* <DropdownItem
                                          className="view-item-btn"
                                          onClick={() => {
                                            setFolderClicked(false);
                                          }}
                                        >
                                          {" "}
                                          OPEN{" "}
                                        </DropdownItem> */}
                                        <DropdownItem className="edit-folder-list" onClick={() => handleFolderRename(item, "file")}>
                                          {" "}
                                          RENAME{" "}
                                        </DropdownItem>
                                        <DropdownItem
                                          className="edit-folder-list"
                                          onClick={() => {
                                            setFileActiveId(item.id);
                                            folderOrFileMoveToggle("file");
                                          }}
                                        >
                                          {" "}
                                          MOVE TO FOLDER{" "}
                                        </DropdownItem>
                                        {userType === "admin" && (
                                          <DropdownItem
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleDeleteFile(item.id);
                                            }}
                                          >
                                            {" "}
                                            DELETE{" "}
                                          </DropdownItem>
                                        )}
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                    </Row>
                  </SimpleBar>
                </div>
              </div>
            </div>
            <div className="file-manager-detail-content p-3 py-0">
              <SimpleBar className="mx-n3 pt-3 px-3 file-detail-content-scroll">
                <div id="folder-overview">
                  <div className="d-flex align-items-center pb-3 border-bottom border-bottom-dashed">
                    <h5 className="flex-grow-1 fw-semibold mb-0">Overview</h5>
                    <div>
                      <button type="button" className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-overview" onClick={() => sidebarClose("file-detail-show")}>
                        <i className="ri-close-fill align-bottom"></i>
                      </button>
                    </div>
                  </div>
                  <SimpleDonutCharts
                    dataColors='["--vz-info", "--vz-danger", "--vz-primary", "--vz-success"]'
                    className="apex-charts mt-3"
                    dir="ltr"
                    img={(fileList || []).reduce((a, v) => (a = a + (v.mimetype === "image/jpeg" || v.mimetype === "image/jpg" || v.mimetype === "image/png" ? parseFloat(v.size) : 0)), 0)}
                    dcm={(fileList || []).reduce((a, v) => (a = a + (v.mimetype === "application/pdf" ? parseFloat(v.size) : 0)), 0)}
                    otr={(fileList || []).reduce((a, v) => (a = a + (v.mimetype !== "image/jpeg" && v.mimetype !== "image/jpg" && v.mimetype !== "image/png" && v.mimetype !== "application/pdf" ? parseFloat(v.size) : 0)), 0)}
                  />
                  <div className="mt-4">
                    <ul className="list-unstyled vstack gap-4">
                      <li>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <div className="avatar-xs">
                              <div className="avatar-title rounded bg-soft-secondary text-secondary">
                                <i className="ri-file-text-line fs-17"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h5 className="mb-1 fs-15">Documents</h5>
                            <p className="mb-0 fs-12 text-muted">{(fileList || []).reduce((a, v) => (a = a + (v.mimetype === "application/pdf" ? 1 : 0)), 0)} Files</p>
                          </div>
                          <span className="fw-semibold fs-12 d-block text-truncate">{formatBytes((fileList || []).reduce((a, v) => (a = a + (v.mimetype === "application/pdf" ? parseFloat(v.size) : 0)), 0))}</span>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <div className="avatar-xs">
                              <div className="avatar-title rounded bg-soft-success text-success">
                                <i className="ri-gallery-line fs-17"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h5 className="mb-1 fs-15">Media</h5>
                            <p className="mb-0 fs-12 text-muted">{(fileList || []).reduce((a, v) => (a = a + (v.mimetype === "image/jpeg" || v.mimetype === "image/jpg" || v.mimetype === "image/png" ? 1 : 0)), 0)} files</p>
                          </div>
                          <span className="fw-semibold fs-12 d-block text-truncate">{formatBytes((fileList || []).reduce((a, v) => (a = a + (v.mimetype === "image/jpeg" || v.mimetype === "image/jpg" || v.mimetype === "image/png" ? parseFloat(v.size) : 0)), 0))}</span>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <div className="avatar-xs">
                              <div className="avatar-title rounded bg-soft-warning text-warning">
                                <i className="ri-folder-2-line fs-17"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h5 className="mb-1 fs-15">Others</h5>
                            <span className="mb-0 fs-12 text-muted">{(fileList || []).reduce((a, v) => (a = a + (v.mimetype === "application/zip" || v.mimetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? 1 : 0)), 0)} files</span>
                          </div>
                          <b>{formatBytes((fileList || []).reduce((a, v) => (a = a + (v.mimetype === "application/zip" || v.mimetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? parseFloat(v.size) : 0)), 0))}</b>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div id="file-overview" className="h-100">
                  <div className="d-flex h-100 flex-column">
                    <div className="d-flex align-items-center pb-3 border-bottom border-bottom-dashed mb-3 gap-2">
                      <h5 className="flex-grow-1 fw-semibold mb-0">File Preview</h5>
                      <div>
                        <button type="button" className="btn btn-ghost-primary btn-icon btn-sm fs-16 favourite-btn">
                          <i className="ri-star-fill align-bottom"></i>
                        </button>
                        <button type="button" className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-overview" onClick={() => sidebarClose("file-detail-show")}>
                          <i className="ri-close-fill align-bottom"></i>
                        </button>
                      </div>
                    </div>

                    <div className="pb-3 border-bottom border-bottom-dashed mb-3">
                      <div className="file-details-box bg-light p-3 text-center rounded-3 border border-light mb-3">
                        <div className="display-4 file-icon">
                          <i className={sidebarData.icon + " text-" + sidebarData.iconClass}></i>
                        </div>
                      </div>
                      <button type="button" className="btn btn-icon btn-sm btn-ghost-success float-end fs-16">
                        <i className="ri-share-forward-line"></i>
                      </button>
                      <h5 className="fs-16 mb-1 file-name">{sidebarData.fileName}</h5>
                      <p className="text-muted mb-0 fs-12">
                        <span className="file-size">{sidebarData.size}</span>, <span className="create-date">{sidebarData.createDate}</span>
                      </p>
                    </div>
                    <div>
                      <h5 className="fs-12 text-uppercase text-muted mb-3">File Description :</h5>

                      <div className="table-responsive">
                        <table className="table table-borderless table-nowrap table-sm">
                          <tbody>
                            <tr>
                              <th scope="row" style={{ width: "35%" }}>
                                File Name :
                              </th>
                              <td className="file-name">{sidebarData.fileName}</td>
                            </tr>
                            <tr>
                              <th scope="row">File Type :</th>
                              <td className="file-type">{sidebarData.fileType}</td>
                            </tr>
                            <tr>
                              <th scope="row">Size :</th>
                              <td className="file-size">{sidebarData.size}</td>
                            </tr>
                            <tr>
                              <th scope="row">Created :</th>
                              <td className="create-date">{sidebarData.createDate}</td>
                            </tr>
                            <tr>
                              <th scope="row">Path :</th>
                              <td className="file-path">
                                <div className="user-select-all text-truncate">*:\projects\src\assets\images</div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div>
                        <h5 className="fs-12 text-uppercase text-muted mb-3">Share Information:</h5>
                        <div className="table-responsive">
                          <table className="table table-borderless table-nowrap table-sm">
                            <tbody>
                              <tr>
                                <th scope="row" style={{ width: "35%" }}>
                                  Share Name :
                                </th>
                                <td className="share-name">\\*\Projects</td>
                              </tr>
                              <tr>
                                <th scope="row">Share Path :</th>
                                <td className="share-path">velzon:\Documents\</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="mt-auto border-top border-top-dashed py-3">
                      <div className="hstack gap-2">
                        <button type="button" className="btn btn-soft-primary w-100">
                          <i className="ri-download-2-line align-bottom me-1"></i> Download
                        </button>
                        <button type="button" className="btn btn-soft-danger w-100 remove-file-overview" onClick={() => handleDeleteFile(sidebarData)}>
                          <i className="ri-close-fill align-bottom me-1"></i> Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </SimpleBar>
            </div>
          </div>
        </Container>
      </div>

      {/* Folder Modal */}
      <Modal className="fade zoomIn" isOpen={modalFolder} toggle={folderToggle} id="createFolderModal" modalClassName="zoomIn" centered tabIndex="-1">
        <ModalHeader className="p-3 bg-soft-success" id="createFolderModalLabel" toggle={folderToggle}>
          {isEdit ? "Ubah Folder" : "Tambah Folder"}
        </ModalHeader>
        <ModalBody>
          <form
            autoComplete="off"
            className="needs-validation createfolder-form"
            id="createfolder-form"
            noValidate=""
            onSubmit={(e) => {
              e.preventDefault();
              folderValidation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-2"> {renderNav()}</div>
            <div className="mb-3">
              <label htmlFor="foldername-input" className="form-label">
                Folder Name
              </label>
              <input type="text" className="form-control" id="foldername-input" name="name" onChange={folderValidation.handleChange} onBlur={folderValidation.handleBlur} value={folderValidation.values.name ?? ""} />
              {folderValidation.touched.name && folderValidation.errors.name ? <FormFeedback type="invalid">{folderValidation.errors.name}</FormFeedback> : null}
            </div>
            <div className="mb-3">
              {/* <Label htmlFor="position" className="form-label">
                Posisi
                {positionLoading && (
                  <Spinner color="primary" size="sm">
                    Loading...
                  </Spinner>
                )}
              </Label> */}
              <Select
                name="department"
                value={folderValidation.values.department}
                placeholder="Pilih Department"
                onChange={(e) => {
                  folderValidation.setFieldValue("department", e);
                }}
                options={departmentOptList}
                invalid={folderValidation.touched.department && folderValidation.errors.department ? true : false}
              ></Select>
              {folderValidation.touched.department && folderValidation.errors.department && (
                <p className="text-danger" type="invalid">
                  {folderValidation.errors.department}
                </p>
              )}
            </div>
            <div className="hstack gap-2 justify-content-end">
              <button type="button" className="btn btn-ghost-success" onClick={folderToggle}>
                <i className="ri-close-line align-bottom"></i> Close
              </button>
              <button type="submit" className="btn btn-primary" id="addNewFolder">
                {isEdit ? "Save" : "Add Folder"}
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>

      {/* modal move folder */}
      <Modal className="fade zoomIn" isOpen={modalMoveFolderOrFile} toggle={folderOrFileMoveToggle} id="createFolderModal" modalClassName="zoomIn" centered tabIndex="-1">
        <ModalHeader className="p-3 bg-soft-success" id="createFolderModalLabel" toggle={folderOrFileMoveToggle}>
          Move to folder
        </ModalHeader>
        <ModalBody>
          <form
            autoComplete="off"
            className="needs-validation createfolder-form"
            id="createfolder-form"
            noValidate=""
            onSubmit={(e) => {
              e.preventDefault();
              handleMoveFolderOrFile();
              return;
            }}
          >
            <div className="mb-3">
              <Label htmlFor="folder-field" className="form-label">
                Folder
              </Label>
              <Select
                name="folder"
                value={selectedMoveFolder.data}
                placeholder="Enter Folder"
                onChange={(e) => {
                  setSelectedMoveFolder((prevVal) => {
                    return {
                      ...prevVal,
                      data: e,
                    };
                  });
                }}
                options={moveType === "folder" ? folderList.filter((f) => !f.parentId) : folderList}
              ></Select>
            </div>
            <div className="hstack gap-2 justify-content-end">
              <button type="button" className="btn btn-ghost-success" onClick={folderOrFileMoveToggle}>
                <i className="ri-close-line align-bottom"></i> Close
              </button>
              <button type="submit" className="btn btn-primary" id="addNewFolder">
                Save
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>

      {/* File Modal */}
      <Modal id="createFileModal" isOpen={modalFile} toggle={fileToggle} modalClassName="zoomIn" centered tabIndex="-1">
        <ModalHeader toggle={fileToggle} className="p-3 bg-soft-success">
          {!!isEdit ? "File Rename" : "Create File"}
        </ModalHeader>
        <ModalBody>
          <form
            className="needs-validation createfile-form"
            id="createfile-form"
            onSubmit={(e) => {
              e.preventDefault();
              fileValidation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-4">
              <label htmlFor="name-input" className="form-label">
                Name
              </label>
              <input type="text" className="form-control" id="name-input" name="name" onChange={fileValidation.handleChange} onBlur={fileValidation.handleBlur} value={fileValidation.values.name ?? ""} />
              {fileValidation.touched.name && fileValidation.errors.name ? <FormFeedback type="invalid">{fileValidation.errors.name}</FormFeedback> : null}
            </div>
            <div className="hstack gap-2 justify-content-end">
              <button type="button" className="btn btn-ghost-success" onClick={fileToggle}>
                <i className="ri-close-line align-bottom"></i> Close
              </button>
              <button type="submit" className="btn btn-primary" id="addNewFile">
                {!!isEdit ? "Save" : "Create"}
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default FileManager;
